import _ from 'underscore';
import Application from '../pages/application';
import { addLibraryAwareObjectToWindow, addUtilityObjectToLibraryAwareObject, addViewsMixinsObjectToLibraryAwareObject, namespace } from './Utilities/initApp';

/**  
 * The following items need to take place in order to boostrap the LibraryAware Backbone.js
 * application:
 * NOTE: Once converted these files to imports, these files should be deleted
 * 1. [DONE] "Scripts/utility/libraryaware.namespace.js"
 * 2. [DONE] "Scripts/Backbone/window.LA.js"
 * 3. [DONE] "Scripts/pages/backbone_utilities.js"
 * 4. [DONE] "Scripts/Backbone/Views/shared.js"
 */

let util = namespace("LibraryAware.Utility");
util.namespace = namespace;

addLibraryAwareObjectToWindow();
addUtilityObjectToLibraryAwareObject();
addViewsMixinsObjectToLibraryAwareObject();

// NOTE: LibraryAware routing was setup in such a way that all client side page request land on 
// the "OrganizationsController.Index()" method which assigns a big blob of data to window.Res

let resources = window.Res;
let LA = window.LA;

// Start the app, passing in dependencies
new Application(_, LA, resources);